import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";

export class CancelPaymentPlanUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string, planId: string): Promise<void> {
        return this.agencyRepository.cancelPaymentPlan(agencyId, planId)
    }
}
